<div class="carousel-container">
  <div class="d-flex ion-justify-content-between">
    <ion-title
      class="ion-no-padding fs-4 font600 title-text-color ion-margin-start"
      >{{ attraction?.display_name }}</ion-title
    >
    <div
      class="see-all-btn d-flex ion-align-items-center marr10"
      *ngIf="IsSeeAll"
    >
      <ion-text
        class="fs-2 font500 title-text-color see-all-text"
        (click)="navigateToServiceListPage()"
        style="cursor: pointer"
        >{{
          "attractions.attractions_service_carousel.see_all" | translate
        }}</ion-text
      >
      <ion-icon
        name="chevron-forward-outline"
        class="fs-3 font500 marl4 primary-icon-color"
      ></ion-icon>
    </div>
  </div>
  <div class="scrollx no-scroll ion-margin-start">
    <div class="scroll-item padt10" *ngFor="let item of attraction?.services">
      <tours-and-experiences-card
        [isMarginRight]="true"
        width="230px"
        [service]="item"
      ></tours-and-experiences-card>
    </div>
  </div>
</div>
